import { processSteps } from "@/mocks/homeContent";

export default function Process() {
  return (
    <section id="process" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-700">
              <span className="h-px w-6 bg-primary-600"></span> 线索征集流程
            </span>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              从提交到核验，四步走
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            清晰的受理标准让每一份材料都被认真对待，也让提交人全程心中有数。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {processSteps.map((s, i) => (
            <div key={s.step} className="relative flex flex-col rounded-lg bg-background-50 p-6">
              <div className="flex items-center justify-between">
                <span className="font-display text-3xl font-black text-primary-600">{s.step}</span>
                {i < processSteps.length - 1 && (
                  <i className="ri-arrow-right-line hidden text-lg text-background-300 lg:block"></i>
                )}
              </div>
              <h3 className="mt-4 font-display text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}